var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMarkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "globalG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.87891 7.57817C11.0505 6.55304 12.95 6.55304 14.1215 7.57817C15.2931 8.6033 15.2931 10.2654 14.1215 11.2905C13.9176 11.4689 13.6917 11.6163 13.4513 11.7326C12.7056 12.0935 12.0002 12.7309 12.0002 13.5593V14.3093M21 12.0593C21 17.0299 16.9706 21.0593 12 21.0593C7.02944 21.0593 3 17.0299 3 12.0593C3 7.08876 7.02944 3.05933 12 3.05933C16.9706 3.05933 21 7.08876 21 12.0593ZM12 17.3093H12.0075V17.3168H12V17.3093Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkCircle);
export default __webpack_public_path__ + "static/media/questionMarkCircle.5fb5322ee36fd7e0c6a6831dd47c32b7.svg";
export { ForwardRef as ReactComponent };